export default __webpack_public_path__ + "static/media/3.9e7aa911.svg";